import { AuthConsumerRenderProps, withAuthContext } from "auth/AuthContext";
import axios from "axios";
import AddEditPatientDocument from "components/clinical-data/AddEditPatientDocument";
import ClinicalDataRecordViewHeader from "components/clinical-data/ClinicalDataRecordViewHeader";
import { getPatientDocumentFileUrl, includesImage } from "components/clinical-data/documentUtils";
import PatientDocumentComments, { prepareComments } from "components/clinical-data/PatientDocumentComments";
import PatientDocumentHistoryView from "components/clinical-data/PatientDocumentHistoryView";
import { PatientHistory } from "components/clinical-data/PatientHistoryView";
import UpsertPrescriptionModal from "components/clinical-data/UpsertPrescriptionModal";
import UpsertUnableToWorkModal from "components/clinical-data/UpsertUnableToWorkModal";
import ConfirmActionButton from "components/ConfirmActionButton";
import EditActionButton from "components/EditActionButton";
import { CheckboxSc } from "components/final-form/CheckBox";
import { DropdownOption, mapToDropdownOptionArrayWithActive } from "components/final-form/dropdownUtils";
import { PxDropdownSc } from "components/final-form/Select";
import TextArea from "components/final-form/TextArea";
import FormButtonsRow from "components/layout/FormButtonsRow";
import FormContainer from "components/layout/FormContainer";
import FormContent from "components/layout/FormContent";
import FormModalContentContainer from "components/layout/FormModalContentContainer";
import PraxFormGrid from "components/layout/PraxFormGrid";
import StyledActionButton from "components/layout/StyledActionButton";
import StyledErrorMessage from "components/layout/StyledErrorMessage";
import { ExtendedColumnProps } from "components/layout/VirtualizedTable";
import LoaderComponent from "components/LoaderComponent";
import { StyledTable } from "components/patient-entry/bookings-table/InterventionBookingsTableView";
import { withPatientCentralRefDataContext } from "components/patient-entry/PatientCentralRefDataContext";
import Patient from "components/patient/Patient";
import { PatientConsumerRenderProps, withPatientContext } from "components/patient/PatientContext";
import UpsertPhysiotherapyReportModal from "components/patient/upsert/UpsertPhysiotherapyReportModal";
import UpsertSynopsisReportModal from "components/patient/upsert/UpsertSynopsisReportModal";
import PatientMedicalDocumentPdfModal from "components/pdf-modal/PatientMedicalDocumentPdfModal";
import PdfModal from "components/pdf-modal/PdfModal";
import UnableToWorkPdfModal from "components/pdf-modal/UnableToWorkPdfModal";
import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { Field, Form as FinalForm } from "react-final-form";
import { MessageSourceProps, withMessages } from "react-message-source";
import { RouterProps } from "react-router";
import {
  Button,
  DropdownProps,
  Grid,
  Icon,
  Loader,
  Message,
  Modal,
  Popup,
  Segment,
  SemanticICONS,
  Tab,
  Table
} from "semantic-ui-react";
import { getAllDoctors } from "services/doctorServices";
import { getPdfUrl } from "services/documentServices";
import { getUpdatedPatientCdrDocumentDto } from "services/patientCdrDocumentServices";
import { getAllPatientDocumentTypes } from "services/patientDocumentTypeServices";
import {
  getPhysiotherapyReport,
  getPrescription,
  getSynopsisReport,
  getUnfit
} from "services/patientMedicalDocumentEditReportServices";
import {
  getCdrDocumentFiles,
  getPatientDocument,
  getPatientDocumentHistory,
  getPatientDocuments,
  getPatientDocumentText,
  getTestCertificateDownloadKey,
  getTestCertificateUrl,
  getTestResultsForPatient,
  getUpsertPatientDocument,
  getVaccinationCertificateForBooking,
  getVaccinationsForPatientClinicalDataRecord,
  makeSynopsisReportCopy,
  revokeTestResult,
  revokeVaccination,
  setAbnormalFindingFlag,
  setDiscussWithPatientFlag,
  setPatientDocumentArchiveFlag,
  setProcedureCreatedFlag,
  setRequiresActionFlag,
  setRequiresDoctorActionFlag
} from "services/patientRecordServices";
import { prescriptionDocument, unableToWorkPatientDocument, vaccinationCardDocument } from "services/patientServices";
import { getUserDisplay } from "services/userSettingsServices";
import styled from "styled-components";
import { PatientDocumentType, PatientReportStatus, TestResultStatus } from "ts-types/api.enums";
import {
  CdrDocumentFileContent,
  DoctorDto,
  InterventionDto,
  PatientCdrDocumentDto,
  PatientDocumentRequest,
  PatientDocumentTypeDto,
  PatientDto,
  PatientEmailFormDto,
  PatientMedicalDocumentHistoryDto,
  PatientPhysiotherapyReportDto,
  PatientSynopsisReportDto,
  PdfResponse,
  PrescriptionDocumentRequest,
  PrescriptionDto,
  TestResultDto,
  UnfitDto,
  UpsertPatientMedicalDocumentDto,
  UserDisplayDto,
  VaccinationDto
} from "ts-types/api.types";
import { isoToDisplayDate } from "utils/dateUtils";
import { errorUtils } from "utils/errorUtils";
import { getText } from "utils/textUtils";
import { withRouterWorkaround } from "utils/workaroundUtils";

const MainContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .page-header.page-header-ps {
    padding-top: 0;
    padding-bottom: 0.875rem !important;
  }

  .page-header .title {
    padding-left: 0.287rem;
    font-size: 1.1rem !important;
    color: #444444;
  }

  .actions-row {
    margin: 0 0.278rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    button {
      margin-right: 0.85rem;
    }
  }

  .actions-row .actions-group {
    display: flex;
    flex-direction: row;
    align-items: baseline;

    .margin-right {
      margin-right: 0.85rem;
    }

    .label {
      color: rgba(0, 0, 0, .87);
      transition: color .1s ease;
    }

    .column {
      display: flex;
      flex-direction: column;
    }

    .horizontal-field {
      display: flex;
      flex-direction: row;

      .label {
        margin-right: 0.5rem;
      }
    }

    .vertical-field {
      display: flex;
      flex-direction: column;
      min-width: 10rem;
    }

    .document-types-dropdown {
      min-width: 17rem;
    }
  }
`;

const StyledCell = styled(Table.Cell)`

  & .test-cert-container:not(:first-child) {
    margin-top: 0.75rem;
  }

  & .test-cert-container {
    display: flex;
    max-width: 6rem;
    justify-self: flex-start;

    .test-cert-member {
      flex: 50%;

      i.icon {
        cursor: pointer;
      }
    }

    .document-cert-member {
      flex: 50%;

      i.icon {
        cursor: pointer;
      }
    }
  }
`;

const StyledPraxContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  overflow: hidden;

  .patient-info-section {
    min-width: 23rem;
    flex: 0 0 auto;
  }

  .ui.segment.table-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    margin: 0 0 0 1rem;
    overflow: hidden;

    .documents-tab {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      overflow: hidden;

      .segment.active.tab.tabular-data-tab {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
      }
    }
  }

  .ui.table.documents-table {
    td {
      vertical-align: baseline;
    }

    .document-date.requires-action {
      color: #957212;
    }

    .document-date.procedure-created {
      color: #46e4b5;
    }

    .document-date.abnormal-finding {
      color: #5293c8;
    }

    .document-date.discuss-with-patient {
      color: #6ab3ee;
    }

    .document-cell {
      .document-type {
        font-weight: bolder;
        color: #555;
      }

      .document-name {
        color: #008db7;
        font-size: 0.95rem;
      }

      .document-description {
        color: #555;
        font-style: italic;
      }

      .document-doctor {
        color: #555;
      }

      .document-currentProblem {
        color: #555;
      }
    }
  }
`;

const StyledTableRow = styled(Table.Row)`
  &.revoked {
    color: rgb(198, 198, 203)
  }

  & .resultStatusIcon {
    margin-left: .5rem
  }

  & .single-line-cell-class {
    max-width: 240px;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
`;

const StyledTab = styled(Tab)`
  .ui.attached.tabular.menu {
    padding-left: 0.85rem;
    border: none !important;
  }

  .ui.attached.segment {
    border: none !important;
  }

  .ui.segment {
    border: none !important;
  }
`;

const StyledButton = styled(Button)`
  padding: 2px !important;
  margin-bottom: 2px !important;
  background: transparent !important;
`;

const TableInfoContainer = styled.div`
  flex-grow: 1;
  cursor: context-menu;
  overflow: auto;
  margin-top: 0.75rem;
  border: 1px solid rgba(34, 36, 38, .15);

  & .ui.table {
    border: none;
  }

  & .ui.table thead tr:first-child > th {
    position: sticky !important;
    top: 0;
    z-index: 2;
    background: #fff;
  }

  & .ui.table td .description-cell {
    word-break: break-word;
  }

  .date-class {
    display: inline-flex;
    padding-right: 5px;
  }

  .icon-class {
    display: inline-flex;
  }
`;

const PopupStyle = {
  borderRadius: 5,
  opacity: 0.7,
  padding: '7px'
};

const styledPane = {
  borderBottom: "none",
  borderLeft: "none",
  borderRight: "none",
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  height: "0"
};

enum ClinicalDataRecordPane {
  PATIENT_HISTORY,
  PATIENT_DOCUMENTS,
  PATIENT_DOCUMENT_TYPE,
  TEST_RESULTS,
  VACCINATIONS
}

interface DocumentActionProps extends MessageSourceProps {
  iconName: SemanticICONS;
  popupMessage: string;
  onClick: () => void;
}

const DocumentActionButtonComp: React.FC<DocumentActionProps> = (
    props: DocumentActionProps) => {

  return <StyledButton
      icon
      type="button"
      onClick={() => props.onClick()}
  >
    <Popup
        trigger={<Icon color="blue" name={props.iconName}/>}
        content={props.getMessage(props.popupMessage)}
        size="small"
        position="top center"
        style={PopupStyle}
        inverted
    />
  </StyledButton>;
};

const DocumentActionButton = withMessages(DocumentActionButtonComp);

interface Props extends RouterProps,
    MessageSourceProps,
    PatientConsumerRenderProps,
    AuthConsumerRenderProps {
}

interface State {
  bookings: VaccinationDto[],
  testResults: TestResultDto[],
  patientDocuments: PatientCdrDocumentDto[],
  patientDocumentTypes: PatientDocumentTypeDto[],
  patientDocumentTypesMap: { [code: string]: PatientDocumentTypeDto },
  patientRecordLoading: boolean,
  patientDocumentHistory: PatientMedicalDocumentHistoryDto[],
  patientDocumentHistoryModalOpen: boolean,
  patientDocumentHistoryLoading: boolean,
  selectedPatientDocument?: PatientCdrDocumentDto,
  prescriptionPdfModalOpen: boolean,
  prescriptionOutput: Array<PatientEmailFormDto>,
  unableToWorkPdfModalOpen: boolean,
  unableToWorkOutput: Array<PatientEmailFormDto>,
  activePane: ClinicalDataRecordPane,
  includingRevoked: boolean,
  includeArchived: boolean,
  procedureCreatedOnly: boolean,
  requiresActionOnly: boolean,
  requiresDoctorActionOnly: boolean,
  abnormalFindingOnly: boolean,
  discussWithPatientOnly: boolean,
  patientDocumentType: PatientDocumentType | null,
  documentTypeOptions: DropdownOption[],
  testCertPdfResponse?: PdfResponse,
  testCertPdfModalOpen: boolean,
  vaccinationCertPdfResponse?: PdfResponse,
  vaccinationCertPdfModalOpen: boolean,
  currentUserDisplay: UserDisplayDto,
  patientMedicalDocumentPdfResponse?: CdrDocumentFileContent[],
  patientMedicalDocumentPdfModalOpen: boolean,
  patientMedicalDocumentTextResponse?: string;
  patientMedicalDocumentTextOpen: boolean;

  reportId?: number;

  synopsisReportDetails?: PatientSynopsisReportDto;
  synopsisModalOpen: boolean,

  physiotherapyReportDetails?: PatientPhysiotherapyReportDto;
  physiotherapyModalOpen: boolean,

  errorMessage?: string,
  uploadPatientDocumentRequest: Partial<UpsertPatientMedicalDocumentDto>,
  patientDocument?: UpsertPatientMedicalDocumentDto,
  patientId?: number,
  documentId?: number,
  documentTypeCode?: string,
  addEditModalOpen: boolean,
  successfullyUploadedMessage?: String,

  doctors: DoctorDto[],

  loadingPatientDocument: boolean,
  editPrescriptionModalOpen: boolean,
  prescriptionDetails?: PrescriptionDto,
  editUnfitModalOpen: boolean,
  unfitDetails?: UnfitDto,
  editUnfitId?: number,
  currentTreaterId?: number,
  showSetControlledButton: boolean
}

class ClinicalDataRecordView extends Component<Props, State> {
  private mounted: boolean = false;

  interventionMap: { [id: number]: InterventionDto } = {};

  cancelTokenSource = axios.CancelToken.source();

  constructor(props: Props) {
    super(props);

    const { getMessage } = this.props;
    const documentTypeLabels: string[] = Object.values(PatientDocumentType);

    this.state = {
      bookings: [],
      testResults: [],
      patientDocuments: [],
      patientDocumentTypes: [],
      patientDocumentTypesMap: {},
      patientRecordLoading: false,
      patientDocumentHistory: [],
      patientDocumentHistoryModalOpen: false,
      patientDocumentHistoryLoading: false,
      prescriptionPdfModalOpen: false,
      prescriptionOutput: [],
      unableToWorkPdfModalOpen: false,
      unableToWorkOutput: [],
      activePane: ClinicalDataRecordPane.PATIENT_HISTORY,
      includingRevoked: false,
      includeArchived: false,
      procedureCreatedOnly: false,
      requiresActionOnly: false,
      requiresDoctorActionOnly: false,
      abnormalFindingOnly: false,
      discussWithPatientOnly: false,
      patientDocumentType: null,
      documentTypeOptions: [],
      testCertPdfModalOpen: false,
      vaccinationCertPdfModalOpen: false,
      currentUserDisplay: {
        id: -1,
        firstName: "",
        name: ""
      },
      patientMedicalDocumentPdfModalOpen: false,
      patientMedicalDocumentTextOpen: false,
      synopsisModalOpen: false,
      physiotherapyModalOpen: false,
      uploadPatientDocumentRequest: {},
      addEditModalOpen: false,
      doctors: [],
      loadingPatientDocument: false,
      editPrescriptionModalOpen: false,
      editUnfitModalOpen: false,
      showSetControlledButton: false
    };

    this.interventionMap = _.keyBy([], "id");
  }

  componentDidMount(): void {
    this.mounted = true;

    this.fetchPatientRecordData();
  }

  componentWillUnmount(): void {
    this.mounted = false;

    this.cancelTokenSource.cancel("Operation canceled by user");
  }

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.currentPatient &&
      this.props.currentPatient &&
      prevProps.currentPatient.id !== this.props.currentPatient.id &&
      this.props.currentPatient.id !== this.state.patientId
    ) {
      this.fetchPatientRecordData(this.props.currentPatient);
    }
  }

  fetchPatientRecordData = async (patient?: PatientDto) => {
    const { currentPatient } = this.props;

    const {
      activePane,
      includingRevoked,
      includeArchived,
      requiresActionOnly,
      requiresDoctorActionOnly,
      abnormalFindingOnly,
      discussWithPatientOnly,
      procedureCreatedOnly,
      patientDocumentType
    } = this.state;

    const documentsTypes = await getAllPatientDocumentTypes(
      this.cancelTokenSource
    );
    this.setState({
      patientDocumentTypes: documentsTypes,
      patientDocumentTypesMap: _.keyBy(documentsTypes, "code"),
      documentTypeOptions: mapToDropdownOptionArrayWithActive(
        documentsTypes,
        docType => this.getDocumentTypeDescriptionFromDto(docType),
        "code",
        "code"
      )
    });

    if (!currentPatient && !patient) {
      this.setState({
        patientRecordLoading: false,
        bookings: [],
        testResults: [],
        patientDocuments: []
      });
      return;
    }

    this.setState({
      patientRecordLoading: true
    });

    try {
      const patientId = patient ? patient.id : currentPatient!.id;
      if (ClinicalDataRecordPane.VACCINATIONS === activePane) {
        const vaccinations = await getVaccinationsForPatientClinicalDataRecord(
          patientId,
          includingRevoked,
          this.cancelTokenSource
        );
        this.setState({
          bookings: vaccinations
        });
      }

      if (ClinicalDataRecordPane.TEST_RESULTS === activePane) {
        const testResults = await getTestResultsForPatient(
          patientId,
          includingRevoked,
          this.cancelTokenSource
        );
        this.setState({
          testResults: testResults
        });
      }
      if (ClinicalDataRecordPane.PATIENT_DOCUMENTS === activePane) {
        const patientDocuments = await getPatientDocuments(
          patientId,
          includeArchived,
          requiresActionOnly,
          requiresDoctorActionOnly,
          abnormalFindingOnly,
          discussWithPatientOnly,
          procedureCreatedOnly,
          patientDocumentType,
          this.cancelTokenSource
        );

        const userDisplay = await getUserDisplay(this.cancelTokenSource);

        this.setState({
          currentUserDisplay: userDisplay,
          patientDocuments: patientDocuments
        });
      }

      const doctors = await getAllDoctors(this.cancelTokenSource);
      this.setState({
        doctors
      });
    } finally {
      this.setState({
        patientRecordLoading: false,
        patientId: patient ? patient.id : currentPatient!.id
      });
    }
  };

  setVaccinationCertPdfModalOpen = (bookingId: number) => {
    getVaccinationCertificateForBooking(bookingId, this.cancelTokenSource)
      .then(response => {
        this.setState({
          vaccinationCertPdfResponse: response,
          vaccinationCertPdfModalOpen: true
        });
      })
      .catch((e: any) => this.handleError(e.response.data));
  };

  setVaccinationCardPdfModalOpen = (patientId: number) => {
    vaccinationCardDocument(patientId, false, this.cancelTokenSource)
      .then(response => {
        this.setState({
          vaccinationCertPdfResponse: response,
          vaccinationCertPdfModalOpen: true
        });
      })
      .catch((e: any) => this.handleError(e.response.data));
  };

  hideVaccinationCertPdfModal = () => {
    this.setState({
      vaccinationCertPdfResponse: undefined,
      vaccinationCertPdfModalOpen: false
    });
  };

  getTestPdfUrl = (pdfResponse: PdfResponse) => {
    return getTestCertificateUrl(pdfResponse.pdfId, pdfResponse.pdfName);
  };

  setTestCertPdfModalOpen = (patientId: number, fileId: string) => {
    getTestCertificateDownloadKey(patientId, fileId, this.cancelTokenSource)
      .then(response => {
        this.setState({
          testCertPdfResponse: response,
          testCertPdfModalOpen: true
        });
      })
      .catch((e: any) => this.handleError(e.response.data));
  };

  setPatientDocumentPdfModalOpen = (document: PatientCdrDocumentDto) => {
    const documentId = document.documentId;
    const patientId = document.patientId;

    getCdrDocumentFiles(patientId, documentId, this.cancelTokenSource)
      .then(response => {
        this.setState({
          patientMedicalDocumentPdfResponse: response,
          patientMedicalDocumentPdfModalOpen: true,
          documentId: documentId
        });
      })
      .catch((e: any) => e.response && this.handleError(e.response.data));

    if (
      PatientDocumentType.PATIENT_SYNOPSIS_REPORT === document.type &&
      (PatientReportStatus.PREPARED === document.reportStatus ||
        document.reportStatus === null)
    ) {
      this.setState({
        showSetControlledButton: true
      });
    }
  };

  setPatientDocumentTextModalOpen = (document: PatientCdrDocumentDto) => {
    const documentId = document.documentId;
    const patientId = document.patientId;

    getPatientDocumentText(patientId, documentId, this.cancelTokenSource)
      .then(response => {
        this.setState({
          patientMedicalDocumentTextResponse: response,
          patientMedicalDocumentTextOpen: true
        });
      })
      .catch((e: any) => this.handleError(e.response.data));
  };

  openPatientMedicalHistory = (document: PatientCdrDocumentDto) => {
    const patientId = document.patientId;

    this.setState({
      selectedPatientDocument: document,
      patientDocumentHistoryLoading: true
    });

    getPatientDocumentHistory(
      patientId,
      document.documentId,
      this.cancelTokenSource
    )
      .then(response => {
        this.setState({
          patientDocumentHistory: response,
          patientDocumentHistoryModalOpen: true
        });
      })
      .finally(() => {
        this.setState({
          patientDocumentHistoryLoading: false
        });
      });
  };

  hidePatientDocumentPdfModal = () => {
    const { currentPatient } = this.props;

    this.setState({
      patientMedicalDocumentPdfResponse: undefined,
      patientMedicalDocumentPdfModalOpen: false,
      showSetControlledButton: false
    });

    this.fetchPatientRecordData(currentPatient);
  };

  hidePatientDocumentTextModal = () => {
    this.setState({
      patientMedicalDocumentTextResponse: undefined,
      patientMedicalDocumentTextOpen: false
    });
  };

  hidePatientDocumentHistoryModal = () => {
    this.setState({
      patientDocumentHistory: [],
      patientDocumentHistoryModalOpen: false,
      patientDocumentHistoryLoading: false
    });
  };

  successfullyChangedReportStatus = () => {
    const { getMessage } = this.props;

    this.setSuccessfulMessage(
      getMessage(
        "patientRecord.patientDocument.successfullySetControlledStatus"
      )
    );
  };

  openEditDocumentDataModal = async (document: PatientCdrDocumentDto) => {
    const reportDataId = document.externalDocumentId;

    if (PatientDocumentType.PATIENT_SYNOPSIS_REPORT == document.type) {
      const response = await getSynopsisReport(
        reportDataId,
        this.cancelTokenSource
      );

      this.setState({
        synopsisReportDetails: { ...response, reportName: document.name },
        reportId: reportDataId,
        synopsisModalOpen: true
      });
    } else if (
      PatientDocumentType.PATIENT_PHYSIOTHERAPY_REPORT == document.type
    ) {
      const response = await getPhysiotherapyReport(
        reportDataId,
        this.cancelTokenSource
      );

      this.setState({
        physiotherapyReportDetails: { ...response, reportName: document.name },
        reportId: reportDataId,
        physiotherapyModalOpen: true
      });
    }
  };

  closeSynopsisModal = (savedDocument: boolean) => {
    this.setState({
      synopsisReportDetails: undefined,
      reportId: undefined,
      synopsisModalOpen: false
    });

    const { currentPatient } = this.props;
    this.fetchPatientRecordData(currentPatient);
  };

  closePhysiotherapyModal = (savedDocument: boolean) => {
    this.setState({
      physiotherapyReportDetails: undefined,
      reportId: undefined,
      physiotherapyModalOpen: false
    });

    const { currentPatient } = this.props;
    this.fetchPatientRecordData(currentPatient);
  };

  openPrescriptionPdf = async (prescriptionId: number, treatmentId: number) => {
    const { currentUser, options } = this.props;

    const prescriptionDocumentRequest: PrescriptionDocumentRequest = {
      prescriptionId: prescriptionId,
      treatmentId: treatmentId,
      treaterId: options.currentTreater!.id,
      mandateId: currentUser!.userConfig!.mandateId
    };

    const response: PatientEmailFormDto[] = await prescriptionDocument(
      prescriptionDocumentRequest,
      this.cancelTokenSource
    );
    await this.openPrescriptionPdfModal(response);
  };

  openPrescriptionPdfModal = (
    prescriptionPdfResponse: PatientEmailFormDto[]
  ) => {
    this.setState({
      prescriptionPdfModalOpen: true,
      prescriptionOutput: prescriptionPdfResponse
    });
  };

  closePrescriptionPdfModal = () => {
    this.setState({
      prescriptionPdfModalOpen: false,
      prescriptionOutput: []
    });
  };

  openPdf = async (document: PatientCdrDocumentDto) => {
    // INFO vg 2025-02-12: remove special handling for prescriptions,
    // to enable adding comments for prescription documents

    // const treatmentId = document.treatmentId;
    // if (document.unfitId !== null) {
    //   this.openUnableToWorkPdf(document.unfitId, treatmentId)
    // } else if (document.prescriptionId !== null) {
    //   this.openPrescriptionPdf(document.prescriptionId, treatmentId)
    // } else {
    //   this.setPatientDocumentPdfModalOpen(document)
    // }

    this.setPatientDocumentPdfModalOpen(document);
  };

  openSynopsisReportCopy = async (document: PatientCdrDocumentDto) => {
    try {
      const response = await makeSynopsisReportCopy(
        document.patientId,
        document.documentId,
        this.cancelTokenSource
      );

      const documentCopyDto = await getPatientDocument(
        document.patientId,
        response.documentId,
        this.cancelTokenSource
      );
      this.openEditDocumentDataModal(documentCopyDto);
    } catch (e) {
      this.handleError(e.response.data);
    }
  };

  openUnableToWorkPdf = async (unabeToWorkId: number, treatmentId: number) => {
    const { currentUser, options } = this.props;

    const patientDocumentRequest: PatientDocumentRequest = {
      treatmentId: treatmentId,
      treaterId: options.currentTreater!.id,
      mandateId: currentUser!.userConfig!.mandateId
    };

    const response: PatientEmailFormDto[] = await unableToWorkPatientDocument(
      patientDocumentRequest,
      this.cancelTokenSource
    );
    await this.openUnableToWorkPdfModal(response);
  };

  openUnableToWorkPdfModal = (
    unableToWorkPdfResponse: PatientEmailFormDto[]
  ) => {
    this.setState({
      unableToWorkPdfModalOpen: true,
      unableToWorkOutput: unableToWorkPdfResponse
    });
  };

  closeUnableToWorkPdfModal = () => {
    this.setState({
      unableToWorkPdfModalOpen: false,
      unableToWorkOutput: []
    });
  };

  hideTestCertPdfModal = () => {
    this.setState({
      testCertPdfResponse: undefined,
      testCertPdfModalOpen: false
    });
  };

  revokeVaccinationForPatient = (id: number) => {
    revokeVaccination(id, this.cancelTokenSource)
      .then(() => this.fetchPatientRecordData())
      .catch((e: any) => this.handleError(e.response.data));
  };

  revokeTestResultForPatient = (id: number) => {
    revokeTestResult(id, this.cancelTokenSource)
      .then(() => this.fetchPatientRecordData())
      .catch((e: any) => this.handleError(e.response.data));
  };

  handleError(error: any) {
    const { getMessage } = this.props;
    const errorCode = error.errorCode;
    const knownErrors: Array<string> = [
      errorUtils.unableToRevokeForCurrentVaccination,
      errorUtils.invalidInput,
      errorUtils.invalidImage,
      errorUtils.imageFormatNotSupported,
      errorUtils.unknownPatientDocumentId,
      errorUtils.invalidDocumentId,
      "CLEAR_REQUIRES_DOCTOR_ACTION_NOT_ALLOWED"
    ];

    const violations: Array<any> = error.violations;

    if (violations && violations.length > 0) {
      violations.forEach(violation => {
        if (knownErrors.includes(violation.errorCode)) {
          this.setErrorMessage(
            getMessage(
              violation.details !== ""
                ? violation.details
                : `error.${violation.errorCode}`
            )
          );
        }
      });
    } else {
      if (knownErrors.includes(errorCode)) {
        this.setErrorMessage(getMessage(`error.${errorCode}`));
      } else {
        this.setErrorMessage(getMessage("error.general"));
      }
    }
  }

  setErrorMessage = (errorMessage?: string) => {
    this.setState({
      errorMessage: errorMessage
    });
  };

  setSuccessfulMessage = (message?: string) => {
    this.setState({
      successfullyUploadedMessage: message
    });
  };

  openAddEditModal = (patientId: number, id?: number | undefined) => {
    if (id) {
      this.setState({
        loadingPatientDocument: true
      });

      getUpsertPatientDocument(patientId, id, this.cancelTokenSource)
        .then(response => {
          this.showModal(id, response);
        })
        .catch((e: any) => this.handleError(e.response.data))
        .finally(() => {
          this.setState({
            loadingPatientDocument: false
          });
        });
    }
  };

  openEditReportModal = (patientDocument: PatientCdrDocumentDto) => {
    const { options } = this.props;

    if (PatientDocumentType.PRESCRIPTION === patientDocument.type) {
      getPrescription(patientDocument.prescriptionId, this.cancelTokenSource)
        .then(response => {
          this.setState({
            prescriptionDetails: response,
            editPrescriptionModalOpen: true,
            currentTreaterId: options.currentTreater!.id
          });
        })
        .catch((e: any) => this.handleError(e.response.data));
    } else if (PatientDocumentType.UNABLE_TO_WORK === patientDocument.type) {
      getUnfit(patientDocument.unfitId, this.cancelTokenSource)
        .then(response => {
          this.setState({
            unfitDetails: response,
            editUnfitId: patientDocument.unfitId,
            editUnfitModalOpen: true,
            currentTreaterId: options.currentTreater!.id
          });
        })
        .catch((e: any) => this.handleError(e.response.data));
    }
  };

  closePrescriptionModal = () => {
    this.setState({
      prescriptionDetails: undefined,
      editPrescriptionModalOpen: false
    });
  };

  closeUnfitModal = () => {
    this.setState({
      unfitDetails: undefined,
      editUnfitModalOpen: false
    });
  };

  showModal = async (
    id?: number,
    patientDocument?: UpsertPatientMedicalDocumentDto
  ) => {
    this.setState({
      addEditModalOpen: true,
      documentId: id,
      patientDocument: patientDocument
    });
  };

  hideModal = () => {
    this.setState({
      addEditModalOpen: false
    });
  };

  onSaveUpsertForm = (
    successfullyUploaded: boolean,
    documentId: number | undefined
  ) => {
    const { getMessage } = this.props;

    if (successfullyUploaded) {
      const msg = "patientRecord.patientDocument.successfullyUploadedMessage";
      this.setSuccessfulMessage(getMessage(msg));
    }
    if (documentId) {
      this.fetchUpdatedDocument(documentId);
    } else {
      this.fetchPatientRecordData();
    }
    this.hideModal();
  };

  fetchUpdatedDocument = async (documentId: number | undefined) => {
    const { patientDocuments } = this.state;

    if (documentId == undefined) {
      return;
    }

    const updatedPatientMedicalDocument = await getUpdatedPatientCdrDocumentDto(
      documentId,
      this.cancelTokenSource
    );

    const newPatientDocuments = patientDocuments.map(patientDocument =>
      patientDocument.documentId == documentId
        ? updatedPatientMedicalDocument
        : patientDocument
    );

    this.setState({
      patientDocuments: newPatientDocuments
    });
  };

  changePatientDocumentArchiveFlag = async (
    patientMedicalDocument: PatientCdrDocumentDto
  ) => {
    const { getMessage } = this.props;

    const type = patientMedicalDocument.type;

    let documentId = patientMedicalDocument.documentId;
    let patientId = patientMedicalDocument.patientId;

    const manualUpload = patientMedicalDocument.manualUpload;
    if (PatientDocumentType.UNABLE_TO_WORK === type && !manualUpload) {
      documentId =
        patientMedicalDocument.unfitId !== null
          ? patientMedicalDocument.unfitId
          : patientMedicalDocument.documentId;
    } else if (PatientDocumentType.PRESCRIPTION === type && !manualUpload) {
      documentId =
        patientMedicalDocument.prescriptionId !== null
          ? patientMedicalDocument.prescriptionId
          : patientMedicalDocument.documentId;
    }

    try {
      const response = await setPatientDocumentArchiveFlag(
        patientId,
        documentId,
        type,
        !patientMedicalDocument.archived,
        this.cancelTokenSource
      );

      const msg = response
        ? "patientRecord.patientDocument.successfullyArchivedMessage"
        : "patientRecord.patientDocument.successfullyUnarchivedMessage";
      this.setSuccessfulMessage(getMessage(msg));
    } catch (e) {
      e.response && this.handleError(e.response.data);
    }

    await this.fetchUpdatedDocument(documentId);
  };

  changeRequiresActionFlag = async (
    patientMedicalDocument: PatientCdrDocumentDto
  ) => {
    const { getMessage } = this.props;

    let documentId = patientMedicalDocument.documentId;
    let patientId = patientMedicalDocument.patientId;

    try {
      const requiresActionNewValue = !patientMedicalDocument.requiresAction;
      const response = await setRequiresActionFlag(
        patientId,
        documentId,
        requiresActionNewValue,
        this.cancelTokenSource
      );

      const msg = response
        ? "patientRecord.patientDocument.successfullySetRequiresAction"
        : "patientRecord.patientDocument.successfullyRemovedRequiresAction";
      this.setSuccessfulMessage(getMessage(msg));
    } catch (e) {
      e.response && this.handleError(e.response.data);
    }

    await this.fetchUpdatedDocument(documentId);
  };

  changeRequiresDoctorActionFlag = async (
    patientMedicalDocument: PatientCdrDocumentDto
  ) => {
    const { getMessage } = this.props;

    let documentId = patientMedicalDocument.documentId;
    let patientId = patientMedicalDocument.patientId;

    try {
      const requiresDoctorActionNewValue = !patientMedicalDocument.requiresDoctorAction;
      const response = await setRequiresDoctorActionFlag(
        patientId,
        documentId,
        requiresDoctorActionNewValue,
        this.cancelTokenSource
      );

      const msg = response
        ? "patientRecord.patientDocument.successfullySetRequiresDoctorAction"
        : "patientRecord.patientDocument.successfullyRemovedRequiresDoctorAction";
      this.setSuccessfulMessage(getMessage(msg));
    } catch (e) {
      e.response && this.handleError(e.response.data);
    }

    await this.fetchUpdatedDocument(documentId);
  };

  changeAbnormalFindingFlag = async (
    patientMedicalDocument: PatientCdrDocumentDto
  ) => {
    const { getMessage } = this.props;

    let documentId = patientMedicalDocument.documentId;
    let patientId = patientMedicalDocument.patientId;

    try {
      const abnormalFindingNewValue = !patientMedicalDocument.abnormalFinding;
      const response = await setAbnormalFindingFlag(
        patientId,
        documentId,
        abnormalFindingNewValue,
        this.cancelTokenSource
      );

      const msg = response
        ? "patientRecord.patientDocument.successfullySetAbnormalFinding"
        : "patientRecord.patientDocument.successfullyRemovedAbnormalFinding";
      this.setSuccessfulMessage(getMessage(msg));
    } catch (e) {
      e.response && this.handleError(e.response.data);
    }

    await this.fetchUpdatedDocument(documentId);
  };

  changeDiscussWithPatientFlag = async (
    patientMedicalDocument: PatientCdrDocumentDto
  ) => {
    const { getMessage } = this.props;

    let documentId = patientMedicalDocument.documentId;
    let patientId = patientMedicalDocument.patientId;

    try {
      const discussWithPatientNewValue = !patientMedicalDocument.discussWithPatient;
      const response = await setDiscussWithPatientFlag(
        patientId,
        documentId,
        discussWithPatientNewValue,
        this.cancelTokenSource
      );

      const msg = response
        ? "patientRecord.patientDocument.successfullySetDiscussWithPatient"
        : "patientRecord.patientDocument.successfullyRemovedDiscussWithPatient";
      this.setSuccessfulMessage(getMessage(msg));
    } catch (e) {
      e.response && this.handleError(e.response.data);
    }

    await this.fetchUpdatedDocument(documentId);
  };

  changeProcedureCreatedFlag = async (
    patientMedicalDocument: PatientCdrDocumentDto
  ) => {
    const { getMessage } = this.props;

    let documentId = patientMedicalDocument.documentId;
    let patientId = patientMedicalDocument.patientId;

    try {
      const procedureCreatedNewValue = !patientMedicalDocument.procedureCreated;
      const response = await setProcedureCreatedFlag(
        patientId,
        documentId,
        procedureCreatedNewValue,
        this.cancelTokenSource
      );

      const msg = response
       ? "patientRecord.patientDocument.successfullySetProcedureCreated"
        : "patientRecord.patientDocument.successfullyRemovedProcedureCreated";
      this.setSuccessfulMessage(getMessage(msg));
    } catch (e) {
      e.response && this.handleError(e.response.data);
    }

    await this.fetchUpdatedDocument(documentId);
  };

  renderTestCertificateCell = (testResult: TestResultDto) => {
    const { getMessage } = this.props;
    return (
      <div className="test-cert-container">
        <div className="test-cert-member">
          {testResult.officialCertificateFileArchiveId && (
            <StyledButton
              icon
              type="button"
              onClick={() =>
                this.setTestCertPdfModalOpen(
                  testResult.patientId,
                  testResult.officialCertificateFileArchiveId
                )
              }
            >
              <Popup
                trigger={<Icon color="red" name="print" />}
                content={getMessage(
                  "patientRecord.testResult.officialCertificate"
                )}
                size="small"
                position="top center"
                style={PopupStyle}
                inverted
              />
            </StyledButton>
          )}
        </div>
        <div className="test-cert-member">
          {testResult.providerCertificateFileArchiveId && (
            <StyledButton
              icon
              type="button"
              onClick={() =>
                this.setTestCertPdfModalOpen(
                  testResult.patientId,
                  testResult.providerCertificateFileArchiveId
                )
              }
            >
              <Popup
                trigger={<Icon color="blue" name="print" />}
                content={getMessage(
                  "patientRecord.testResult.providerCertificate"
                )}
                size="small"
                position="top center"
                style={PopupStyle}
                inverted
              />
            </StyledButton>
          )}
        </div>
      </div>
    );
  };

  renderVaccinationCertificateCell = (vaccination: VaccinationDto) => {
    const { getMessage } = this.props;
    return (
      <div className="test-cert-container">
        <div className="test-cert-member">
          {vaccination.certificateId && (
            <StyledButton
              icon
              type="button"
              onClick={() =>
                this.setVaccinationCertPdfModalOpen(
                  vaccination.interventionBookingId
                )
              }
            >
              <Popup
                trigger={<Icon color="blue" name="print" />}
                content={getMessage(
                  "patientRecord.testResult.officialCertificate"
                )}
                size="small"
                position="top center"
                style={PopupStyle}
                inverted
              />
            </StyledButton>
          )}
          <StyledButton
            icon
            type="button"
            onClick={() =>
              this.setVaccinationCardPdfModalOpen(vaccination.patientId)
            }
          >
            <Popup
              trigger={<Icon color="red" name="print" />}
              content={getMessage(
                "patientRecord.testResult.officialCertificate"
              )}
              size="small"
              position="top center"
              style={PopupStyle}
              inverted
            />
          </StyledButton>
        </div>
      </div>
    );
  };

  renderPatientDocumentName = (patientDocument: PatientCdrDocumentDto) => {
    const docType = patientDocument.type;

    return "UNABLE_TO_WORK" !== docType && "PRESCRIPTION" !== docType
      ? patientDocument.name
      : this.getDocumentTypeDescription(docType);
  };

  getDocumentTypeDescription = (documentType: string) => {
    const { language } = this.props;
    return getText(
      this.state.patientDocumentTypesMap[documentType].description,
      language
    );
  };

  getDocumentTypeDescriptionFromDto = (
    documentType: PatientDocumentTypeDto
  ) => {
    const { language } = this.props;
    return getText(documentType.description, language);
  };

  renderDoctorPatientDocumentCell = (doctorId: number) => {
    const { doctors } = this.state;

    let doctorName = "";
    const doctor = doctors.find(doc => doc.id === doctorId);

    if (doctor) {
      const name = doctor.name !== null ? doctor.name : "";
      const firstName = doctor.firstName !== null ? doctor.firstName : "";

      doctorName = name + " " + firstName;
    }

    return doctorName;
  };

  renderCommentCell = (document: PatientCdrDocumentDto) => {
    if (document == null || _.isEmpty(document.comments)) {
      return <></>;
    }

    return (
      <PatientDocumentComments
        readonly
        comments={prepareComments(document.comments)}
      />
    );
  };

  renderDownloadPatientDocumentCell = (
    patientDocument: PatientCdrDocumentDto
  ) => {
    const { getMessage } = this.props;
    return (
      <>
        <div className="test-cert-container">
          <div className="document-cert-member">
            <div>
              <ConfirmActionButton
                popupMessage={patientDocument.requiresAction
                    ? getMessage("patientRecord.patientDocument.removeRequiresAction")
                    : getMessage("patientRecord.patientDocument.setRequiresAction")
                }
                popupPosition="bottom center"
                trigger={
                  <Icon
                      title={getMessage("patientRecord.patientDocument.requiresAction")}
                      name={"warning circle"}
                      color={patientDocument.requiresAction ? "yellow" : "grey"}
                      style={{cursor: 'pointer'}}
                  />
                }
                onConfirm={() => this.changeRequiresActionFlag(patientDocument)}
              />
            </div>
          </div>

          <div className="document-cert-member">
            <div>
              <ConfirmActionButton
                popupMessage={patientDocument.requiresDoctorAction
                    ? getMessage("patientRecord.patientDocument.removeRequiresDoctorAction")
                    : getMessage("patientRecord.patientDocument.setRequiresDoctorAction")
                }
                popupPosition="bottom center"
                trigger={
                  <Icon
                    title={getMessage("patientRecord.patientDocument.requiresDoctorAction")}
                    name={patientDocument.requiresDoctorAction ? "bell" : "bell slash outline"}
                    color={patientDocument.requiresDoctorAction ? "purple" : "grey"}
                    style={{ cursor: "pointer" }}
                  />
                }
                onConfirm={() => this.changeRequiresDoctorActionFlag(patientDocument)}
              />
            </div>
          </div>

          <div className="document-cert-member">
            <div>
              <ConfirmActionButton
                popupMessage={patientDocument.abnormalFinding
                    ? getMessage("patientRecord.patientDocument.removeAbnormalFinding")
                    : getMessage("patientRecord.patientDocument.setAbnormalFinding")
                }
                popupPosition="bottom center"
                trigger={
                  <Icon
                    title={getMessage("patientRecord.patientDocument.abnormalFinding")}
                    name={patientDocument.abnormalFinding ? "flag" : "flag outline"}
                    color={patientDocument.abnormalFinding ? "red" : "grey"}
                    style={{ cursor: "pointer" }}
                  />
                }
                onConfirm={() => this.changeAbnormalFindingFlag(patientDocument)}
              />
            </div>
          </div>

          <div className="document-cert-member">
            <div>
              <ConfirmActionButton
                popupMessage={patientDocument.discussWithPatient
                    ? getMessage("patientRecord.patientDocument.removeDiscussWithPatient")
                    : getMessage("patientRecord.patientDocument.setDiscussWithPatient")
                }
                popupPosition="bottom center"
                trigger={
                  <Icon
                    title={getMessage("patientRecord.patientDocument.discussWithPatient")}
                    name={patientDocument.discussWithPatient ? "phone" : "phone"}
                    color={patientDocument.discussWithPatient ? "blue" : "grey"}
                    style={{ cursor: "pointer" }}
                  />
                }
                onConfirm={() => this.changeDiscussWithPatientFlag(patientDocument)}
              />
            </div>
          </div>

          <div className="document-cert-member">
            <div>
              <ConfirmActionButton
                popupMessage={
                  patientDocument.procedureCreated
                    ? getMessage("patientRecord.patientDocument.removeProcedureCreated")
                    : getMessage("patientRecord.patientDocument.setProcedureCreated")
                }
                popupPosition="bottom center"
                trigger={
                  <Icon
                    title={getMessage("patientRecord.patientDocument.procedureCreated")}
                    name={patientDocument.procedureCreated ? "dollar" : "dollar"}
                    color={patientDocument.procedureCreated ? "green" : "grey"}
                    style={{ cursor: "pointer" }}
                  />
                }
                onConfirm={() => this.changeProcedureCreatedFlag(patientDocument)}
              />
            </div>
          </div>
        </div>

        <div className="test-cert-container">
          {(patientDocument.documentFile || patientDocument.documentText) && (
            <div className="document-cert-member">
              {patientDocument.documentFile ? (
                <div style={{ display: "flex" }}>
                  <DocumentActionButton
                    iconName="print"
                    popupMessage={`${this.getDocumentTypeDescription(
                      patientDocument.type
                    )}`}
                    onClick={() => this.openPdf(patientDocument)}
                  />
                  {patientDocument.type === "PATIENT_SYNOPSIS_REPORT" &&
                    !patientDocument.manualUpload && (
                      <DocumentActionButton
                        iconName="copy"
                        popupMessage={
                          "patientRecord.patientDocument.documentDuplicate"
                        }
                        onClick={() =>
                          this.openSynopsisReportCopy(patientDocument)
                        }
                      />
                    )}
                </div>
              ) : patientDocument.documentText ? (
                this.renderTextDocumentIcon(patientDocument)
              ) : (
                ""
              )}
            </div>
          )}

          {includesImage(patientDocument) &&
            patientDocument.documentText &&
            this.renderTextDocumentIcon(patientDocument)}

          {patientDocument.manualUpload && (
            <DocumentActionButton
              iconName="edit"
              popupMessage="msgEdit"
              onClick={() =>
                this.openAddEditModal(
                  patientDocument.patientId,
                  patientDocument.documentId
                )
              }
            />
          )}

          {!patientDocument.manualUpload &&
            (patientDocument.type ===
              PatientDocumentType.PATIENT_SYNOPSIS_REPORT ||
              patientDocument.type ===
                PatientDocumentType.PATIENT_PHYSIOTHERAPY_REPORT) && (
              <EditActionButton
                trigger={<Icon name={"pencil"} />}
                hoverMessage={"Edit report"}
                onConfirm={() =>
                  this.openEditDocumentDataModal(patientDocument)
                }
              />
            )}

          {/* this needs to consider the cases where the treatment
              can't be modified (deleted/closed/billed)
          {!patientDocument.manualUpload && (
                  patientDocument.type === PatientDocumentType.PRESCRIPTION ||
                  patientDocument.type === PatientDocumentType.UNABLE_TO_WORK) &&
              <EditActionButton
                  hoverMessage={"Edit report"}
                  onConfirm={() => this.openEditReportModal(patientDocument)}/>
          }*/}

          <div className="document-cert-member">
            <DocumentActionButton
              iconName="archive"
              popupMessage={
                patientDocument.archived
                  ? getMessage("patientRecord.patientDocument.unarchiveDocument")
                  : getMessage("patientRecord.patientDocument.archiveDocument")
              }
              onClick={() => this.changePatientDocumentArchiveFlag(patientDocument)}
            />
          </div>

          <div className="document-cert-member">
            {this.renderDocumentHistory(patientDocument)}
          </div>
        </div>
      </>
    );
  };

  renderDocumentHistory = (patientDocument: PatientCdrDocumentDto) => {
    const { getMessage } = this.props;

    return (
      patientDocument.documentId !== null && (
        <DocumentActionButton
          iconName="history"
          popupMessage="patientRecord.patientDocument.documentHistory.title"
          onClick={() => this.openPatientMedicalHistory(patientDocument)}
        />
      )
    );
  };

  renderTextDocumentIcon = (patientDocument: PatientCdrDocumentDto) => {
    const { getMessage } = this.props;

    return (
      <DocumentActionButton
        iconName="file alternate outline"
        popupMessage="patientRecord.patientDocument.document"
        onClick={() => this.setPatientDocumentTextModalOpen(patientDocument)}
      />
    );
  };

  renderRevokeCell = (vaccination: VaccinationDto) => {
    const { getMessage } = this.props;

    if (vaccination.status === TestResultStatus.VALID) {
      const trigger = (
        <Icon
          name={"remove circle"}
          color={"red"}
          style={{ cursor: "pointer" }}
        />
      );

      return (
        <div>
          <ConfirmActionButton
            popupMessage={getMessage("patientRecord.vaccination.confirmRevoke")}
            popupPosition="bottom center"
            trigger={trigger}
            onConfirm={() => this.revokeVaccinationForPatient(vaccination.id)}
          />
        </div>
      );
    }

    return "";
  };

  renderRevokeTestCertificateCell = (testResult: TestResultDto) => {
    const { getMessage } = this.props;

    if (testResult.resultStatus === TestResultStatus.VALID) {
      const trigger = (
        <Icon
          name={"remove circle"}
          color={"red"}
          style={{ cursor: "pointer" }}
        />
      );

      return (
        <div>
          <ConfirmActionButton
            popupMessage={getMessage("patientRecord.testResult.confirmRevoke")}
            popupPosition="bottom center"
            trigger={trigger}
            onConfirm={() => this.revokeTestResultForPatient(testResult.id)}
          />
        </div>
      );
    }

    return "";
  };

  handleCheckBoxChange = (): void => {
    this.setState(
      oldState => {
        const newIncludingRevokedState = !oldState.includingRevoked;
        return { includingRevoked: newIncludingRevokedState };
      },
      () => {
        this.fetchPatientRecordData();
      }
    );
  };

  handleIncludeArchivedChange = (): void => {
    this.setState(
      oldState => {
        const newIncludingArchivedState = !oldState.includeArchived;
        return { includeArchived: newIncludingArchivedState };
      },
      () => {
        this.fetchPatientRecordData();
      }
    );
  };

  handleRequiresActionChange = (): void => {
    this.setState(
      oldState => {
        const newRequiresActionState = !oldState.requiresActionOnly;
        return {
          requiresActionOnly: newRequiresActionState,
          requiresDoctorActionOnly: false
        };
      },
      () => {
        this.fetchPatientRecordData();
      }
    );
  };

  handleRequiresDoctorActionChange = (): void => {
    this.setState(
      oldState => {
        const newRequiresDoctorActionState = !oldState.requiresDoctorActionOnly;
        return {
          requiresActionOnly: false,
          requiresDoctorActionOnly: newRequiresDoctorActionState
        };
      },
      () => {
        this.fetchPatientRecordData();
      }
    );
  };

  handleAbnormalFindingChange = (): void => {
    this.setState(
      oldState => {
        const newAbnormalFindingState = !oldState.abnormalFindingOnly;
        return {
          abnormalFindingOnly: newAbnormalFindingState
        };
      },
      () => {
        this.fetchPatientRecordData();
      }
    );
  };

  handleDiscussWithPatientChange = (): void => {
    this.setState(
      oldState => {
        const newDiscussWithPatientState = !oldState.discussWithPatientOnly;
        return {
          discussWithPatientOnly: newDiscussWithPatientState
        };
      },
      () => {
        this.fetchPatientRecordData();
      }
    );
  };

  handleProcedureCreatedChange = (): void => {
    this.setState(
      oldState => {
        const newProcedureCreatedState = !oldState.procedureCreatedOnly;
        return {
          procedureCreatedOnly: newProcedureCreatedState
        };
      },
      () => {
        this.fetchPatientRecordData();
      }
    );
  };

  onPatientDocumentTypeChange = (documentType: any) => {
    this.setState(
      oldState => {
        const newState = oldState != documentType ? documentType : null;
        return { patientDocumentType: newState };
      },
      () => {
        this.fetchPatientRecordData();
      }
    );
  };

  handleTabChange = async (
    event: React.MouseEvent<HTMLDivElement>,
    data: any
  ) => {
    await this.setState({
      activePane: data.activeIndex
    });

    try {
      this.cancelTokenSource.cancel();
      this.cancelTokenSource = axios.CancelToken.source();
    } catch (e) {
      // ignore
    }

    this.fetchPatientRecordData();
  };

  render(): React.ReactNode {
    const { getMessage } = this.props;
    const {
      activePane,
      testCertPdfModalOpen,
      vaccinationCertPdfModalOpen,
      vaccinationCertPdfResponse,
      testCertPdfResponse,
      prescriptionOutput,
      prescriptionPdfModalOpen,
      unableToWorkOutput,
      unableToWorkPdfModalOpen,
      patientMedicalDocumentPdfModalOpen,
      patientMedicalDocumentPdfResponse,
      successfullyUploadedMessage,
      loadingPatientDocument,
      editPrescriptionModalOpen,
      editUnfitModalOpen,
      errorMessage,
      patientId,
      documentId,
      showSetControlledButton
    } = this.state;

    const panes = [
      {
        menuItem: getMessage("clinicalData.home.searchBy.patientHistory"),
        pane: {
          key: ClinicalDataRecordPane.PATIENT_HISTORY,
          className: "tabular-data-tab",
          style: styledPane
        },
        render: () => this.renderPatientHistoryPane()
      },
      {
        menuItem: getMessage("clinicalData.home.searchBy.patientDocuments"),
        pane: {
          key: ClinicalDataRecordPane.PATIENT_DOCUMENTS,
          className: "tabular-data-tab",
          style: styledPane
        },
        render: () => this.renderPatientDocumentPane()
      },
      {
        menuItem: getMessage("clinicalData.home.searchBy.testResult"),
        pane: {
          key: ClinicalDataRecordPane.TEST_RESULTS,
          className: "tabular-data-tab",
          style: styledPane
        },
        render: () => this.renderTestResultsPane()
      },
      {
        menuItem: getMessage("clinicalData.home.searchBy.vaccination"),
        pane: {
          key: ClinicalDataRecordPane.VACCINATIONS,
          className: "tabular-data-tab",
          style: styledPane
        },
        render: () => this.renderVaccinationPane()
      }
    ];

    return (
      <MainContentDiv>
        <ClinicalDataRecordViewHeader className={"page-header-ps"} />
        {errorMessage && (
          <StyledErrorMessage onDismiss={() => this.setErrorMessage()}>
            {errorMessage}
          </StyledErrorMessage>
        )}
        {successfullyUploadedMessage && (
          <Message
            success
            onDismiss={() => this.setSuccessfulMessage(undefined)}
          >
            {successfullyUploadedMessage}
          </Message>
        )}
        {loadingPatientDocument &&
          !(activePane === ClinicalDataRecordPane.PATIENT_DOCUMENTS) && (
            <LoaderComponent message={getMessage("loading")} />
          )}
        <StyledPraxContainer id="clinicalDataRecordMainContent">
          <div className="patient-info-section">
            <Patient
              isHome={false}
              changePatient={(patient?: PatientDto) => {
                this.props.changePatient(patient);
                this.fetchPatientRecordData(patient);
              }}
            />
          </div>
          <Segment className="table-container">
            <StyledTab
              className="documents-tab"
              menu={{ secondary: true, pointing: true }}
              panes={panes}
              renderActiveOnly={true}
              onTabChange={this.handleTabChange}
            />
          </Segment>
          {testCertPdfModalOpen && (
            <PdfModal
              pdfResponses={[testCertPdfResponse]}
              modalOpen={testCertPdfModalOpen}
              getPdfUrl={this.getTestPdfUrl}
              onCloseModal={() => this.hideTestCertPdfModal()}
            />
          )}
          {vaccinationCertPdfModalOpen && (
            <PdfModal
              pdfResponses={[vaccinationCertPdfResponse]}
              modalOpen={vaccinationCertPdfModalOpen}
              getPdfUrl={getPdfUrl}
              onCloseModal={() => this.hideVaccinationCertPdfModal()}
            />
          )}
          {unableToWorkPdfModalOpen && (
            <UnableToWorkPdfModal
              modalOpen={unableToWorkOutput}
              onCloseModal={this.closeUnableToWorkPdfModal}
              pdfResponses={unableToWorkOutput}
              getPdfUrl={getPdfUrl}
            />
          )}
          {prescriptionPdfModalOpen && (
            <UnableToWorkPdfModal
              modalOpen={prescriptionPdfModalOpen}
              onCloseModal={this.closePrescriptionPdfModal}
              pdfResponses={prescriptionOutput}
              getPdfUrl={getPdfUrl}
            />
          )}
          {patientMedicalDocumentPdfModalOpen && (
            <PatientMedicalDocumentPdfModal
              pdfResponses={patientMedicalDocumentPdfResponse}
              modalOpen={patientMedicalDocumentPdfModalOpen}
              onCloseModal={this.hidePatientDocumentPdfModal}
              getPdfUrl={getPatientDocumentFileUrl}
              textContent={
                patientMedicalDocumentPdfResponse![0].textContent
                  ? patientMedicalDocumentPdfResponse![0].textContent
                  : ""
              }
              comments={prepareComments(
                patientMedicalDocumentPdfResponse![0].comments || []
              )}
              currentUserDisplay={this.state.currentUserDisplay}
              patientId={patientId}
              documentId={documentId}
              showSetControlledButton={showSetControlledButton}
              successfullyChangedReportStatus={this.successfullyChangedReportStatus}
            />
          )}
          {this.renderPatientDocumentHistoryModal()}
          {this.renderUpsertPatientDocumentModal()}
          {this.renderPatientMedicalDocumentTextModal()}
          {editPrescriptionModalOpen && this.renderPrescriptionForm()}
          {editUnfitModalOpen && this.renderUnfitForm()}
        </StyledPraxContainer>
      </MainContentDiv>
    );
  }

  renderPatientDocumentHistoryModal = (): React.ReactNode => {
    const { getMessage } = this.props;
    const {
      patientDocumentHistoryModalOpen,
      patientDocumentHistory,
      selectedPatientDocument,
      doctors
    } = this.state;

    return (
      <Modal
        open={patientDocumentHistoryModalOpen}
        onClose={this.hidePatientDocumentHistoryModal}
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          {getMessage("patientRecord.patientDocument.documentHistory.title")}
        </Modal.Header>
        <FormModalContentContainer>
          <PatientDocumentHistoryView
            patientDocumentTypesMap={this.state.patientDocumentTypesMap}
            patientDocument={selectedPatientDocument}
            patientDocumentHistory={patientDocumentHistory}
            doctors={doctors}
            onCloseModal={this.hidePatientDocumentHistoryModal}
          />
        </FormModalContentContainer>
      </Modal>
    );
  };

  renderUpsertPatientDocumentModal = (): React.ReactNode => {
    const { getMessage } = this.props;

    const {
      addEditModalOpen,
      patientDocument,
      patientId,
      documentId
    } = this.state;

    if (!addEditModalOpen) {
      return <></>;
    }

    const headerMessage = documentId
      ? getMessage("patientRecord.patientDocument.editPatientDocument.header")
      : getMessage(
          "patientRecord.patientDocument.uploadPatientDocument.header"
        );

    return (
      <Modal
        open={addEditModalOpen}
        onClose={() => this.hideModal()}
        closeOnDimmerClick={false}
      >
        <Modal.Header>{headerMessage}</Modal.Header>
        <FormModalContentContainer>
          <AddEditPatientDocument
            onCancel={this.hideModal}
            onSave={this.onSaveUpsertForm}
            patientDocument={patientDocument}
            patientId={patientId}
            documentId={documentId}
            patient={this.props.currentPatient}
          />
        </FormModalContentContainer>
      </Modal>
    );
  };

  renderPatientMedicalDocumentTextModal = (): React.ReactNode => {
    const { patientMedicalDocumentTextOpen } = this.state;
    const { getMessage } = this.props;

    return (
      <Modal
        open={patientMedicalDocumentTextOpen}
        onClose={() => this.hidePatientDocumentTextModal()}
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          {getMessage("patientRecord.patientDocument.textDocument.modalHeader")}
        </Modal.Header>
        <FormModalContentContainer>
          {this.renderPatientDocumentTextModalContent()}
        </FormModalContentContainer>
      </Modal>
    );
  };

  renderPatientDocumentTextModalContent = () => {
    const { patientMedicalDocumentTextResponse } = this.state;
    return (
      <FinalForm
        onSubmit={() => {}}
        initialValues={{ textContent: patientMedicalDocumentTextResponse }}
        subscription={{ pristine: true, submitting: true }}
        render={this.renderForm}
      />
    );
  };

  renderForm = () => {
    const { getMessage } = this.props;

    return (
      <FormContainer>
        <FormContent>
          <PraxFormGrid>
            <Grid.Row>
              <Grid.Column>
                <label htmlFor="textContent">
                  {getMessage(
                    "patientRecord.patientDocument.uploadPatientDocument.comment"
                  )}
                </label>
                <Field
                  name="textContent"
                  component={TextArea}
                  style={{
                    minHeight: "20vh",
                    maxHeight: "70vh",
                    height: "70vh"
                  }}
                />
              </Grid.Column>
            </Grid.Row>
          </PraxFormGrid>
          <FormButtonsRow>
            <div style={{ float: "right" }}>
              <Button
                compact
                type="button"
                onClick={this.hidePatientDocumentTextModal}
              >
                {getMessage("button.cancel")}
              </Button>
            </div>
          </FormButtonsRow>
        </FormContent>
      </FormContainer>
    );
  };

  renderVaccinationPane = (): React.ReactNode => {
    const { getMessage } = this.props;
    const { bookings, patientRecordLoading, includingRevoked } = this.state;

    if (patientRecordLoading) {
      return <Loader active={true} size="small" />;
    }

    if (bookings.length <= 0) {
      return <></>;
    }

    return (
      <React.Fragment>
        <div className="actions-row">
          <CheckboxSc
            checked={includingRevoked}
            label={getMessage("patientRecord.testResult.includingRevoked")}
            toggle={true}
            onChange={() => this.handleCheckBoxChange()}
          />
        </div>

        <TableInfoContainer>
          <Table compact="very">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  {getMessage("patientRecord.vaccination.medicament")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientRecord.vaccination.lotNumber")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientRecord.vaccination.dosis")}
                </Table.HeaderCell>
                <Table.HeaderCell>{getMessage("date")}</Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientRecord.vaccination.certificate")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("common.revoke")}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {bookings.map(booking => (
                <Table.Row key={booking.id}>
                  <Table.Cell>{booking.medicamentDescription}</Table.Cell>
                  <Table.Cell>{booking.lotNumber}</Table.Cell>
                  <Table.Cell>{booking.dosis}</Table.Cell>
                  <Table.Cell>{isoToDisplayDate(booking.date)}</Table.Cell>
                  <Table.Cell>
                    {this.renderVaccinationCertificateCell(booking)}
                  </Table.Cell>
                  <Table.Cell>{this.renderRevokeCell(booking)}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </TableInfoContainer>
      </React.Fragment>
    );
  };

  renderTestResultsPane = (): React.ReactNode => {
    const { getMessage } = this.props;
    const { testResults, patientRecordLoading, includingRevoked } = this.state;

    if (patientRecordLoading) {
      return <Loader active={true} size="small" />;
    }

    if (testResults.length <= 0) {
      return <></>;
    }

    return (
      <React.Fragment>
        <div className="actions-row">
          <CheckboxSc
            checked={includingRevoked}
            label={getMessage("patientRecord.testResult.includingRevoked")}
            toggle={true}
            onChange={() => this.handleCheckBoxChange()}
          />
        </div>

        <TableInfoContainer>
          <Table compact="very">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  {getMessage("patientRecord.testResult.externalCode")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientRecord.testResult.testKitCode")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientRecord.testResult.testingDate")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientRecord.testResult.testResult")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientRecord.testResult.resultDate")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("patientRecord.testResult.certificates")}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  {getMessage("common.revoke")}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {testResults.map(testResult => {
                const isRevoked =
                  testResult.resultStatus === TestResultStatus.REVOKED;
                return (
                  <StyledTableRow
                    key={testResult.id}
                    className={isRevoked ? "revoked" : ""}
                  >
                    <Table.Cell>
                      {getMessage(
                        `enum.InterventionExternalCode.${
                          testResult.externalCode
                        }`
                      )}
                      <Icon
                        className={"resultStatusIcon"}
                        color={isRevoked ? "grey" : "blue"}
                        title={isRevoked ? "revoked" : "valid"}
                        name="certificate"
                      />
                    </Table.Cell>
                    <Table.Cell>{testResult.testKitCode}</Table.Cell>
                    <Table.Cell>
                      {moment(testResult.testingDate).format(
                        "DD.MM.YYYY HH:mm"
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {getMessage(`enum.testResult.${testResult.testResult}`)}
                    </Table.Cell>
                    <Table.Cell>
                      {moment(testResult.resultDate).format("DD.MM.YYYY HH:mm")}
                    </Table.Cell>
                    <StyledCell>
                      {this.renderTestCertificateCell(testResult)}
                    </StyledCell>
                    <Table.Cell>
                      {this.renderRevokeTestCertificateCell(testResult)}
                    </Table.Cell>
                  </StyledTableRow>
                );
              })}
            </Table.Body>
          </Table>
        </TableInfoContainer>
      </React.Fragment>
    );
  };

  renderPrescriptionForm = () => {
    const { currentPatient, getMessage } = this.props;

    const {
      editPrescriptionModalOpen,
      prescriptionDetails,
      patientId,
      currentTreaterId
    } = this.state;

    const prescriptionPatientId = patientId ? patientId : currentPatient!.id;

    return (
      <Modal
        size="large"
        open={editPrescriptionModalOpen}
        onClose={() => this.closePrescriptionModal}
        closeOnDimmerClick={false}
      >
        <Modal.Header>{getMessage("prescription.title")}</Modal.Header>
        <FormModalContentContainer>
          <UpsertPrescriptionModal
            patientId={prescriptionPatientId}
            currentTreaterId={currentTreaterId}
            prescription={prescriptionDetails}
            onCloseEditPrescription={this.closePrescriptionModal}
          />
        </FormModalContentContainer>
      </Modal>
    );
  };

  renderUnfitForm = () => {
    const { currentPatient, getMessage } = this.props;
    const {
      unfitDetails,
      editUnfitModalOpen,
      patientId,
      editUnfitId,
      currentTreaterId
    } = this.state;

    const unfitPatientId = patientId ? patientId : currentPatient!.id;

    return (
      <Modal
        size="large"
        open={editUnfitModalOpen}
        onClose={() => this.closeUnfitModal()}
        closeOnDimmerClick={false}
      >
        <Modal.Header>{getMessage("unfit.titleHeader")}</Modal.Header>
        <FormModalContentContainer>
          <UpsertUnableToWorkModal
            patientId={unfitPatientId}
            documentId={editUnfitId}
            currentTreaterId={currentTreaterId}
            unfit={unfitDetails}
            onCloseEditUnfit={this.closeUnfitModal}
          />
        </FormModalContentContainer>
      </Modal>
    );
  };

  renderPatientDocumentPane = (): React.ReactNode => {
    const { getMessage, currentPatient } = this.props;

    const {
      loadingPatientDocument,
      patientDocuments,
      patientRecordLoading,
      includeArchived,
      requiresActionOnly,
      requiresDoctorActionOnly,
      abnormalFindingOnly,
      discussWithPatientOnly,
      procedureCreatedOnly,
      patientDocumentType,
      documentTypeOptions
    } = this.state;

    if (!currentPatient) {
      return <></>;
    }

    const loadingData = patientRecordLoading || loadingPatientDocument;

    return (
      <React.Fragment>
        <div className="actions-row">
          <div className="actions-group">
            <StyledActionButton
              type="button"
              size="medium"
              compact
              onClick={() => this.fetchPatientRecordData()}
            >
              <Icon name="refresh" />
              {getMessage("button.reload")}
            </StyledActionButton>

            <div className="column margin-right">
              <CheckboxSc
                checked={includeArchived}
                label={getMessage("patientRecord.testResult.includeArchived")}
                onChange={() => this.handleIncludeArchivedChange()}
              />

              <CheckboxSc
                checked={requiresActionOnly}
                label={getMessage(
                  "patientRecord.patientDocument.requiresAction"
                )}
                onChange={() => this.handleRequiresActionChange()}
              />

              <CheckboxSc
                checked={requiresDoctorActionOnly}
                label={getMessage(
                  "patientRecord.patientDocument.requiresDoctorAction"
                )}
                onChange={() => this.handleRequiresDoctorActionChange()}
              />
            </div>

            <div className="column margin-right">
              <CheckboxSc
                checked={abnormalFindingOnly}
                label={getMessage(
                  "patientRecord.patientDocument.abnormalFinding"
                )}
                onChange={() => this.handleAbnormalFindingChange()}
              />

              <CheckboxSc
                checked={discussWithPatientOnly}
                label={getMessage("patientRecord.patientDocument.discussWithPatient")}
                onChange={() => this.handleDiscussWithPatientChange()}
              />
            </div>

            <div className="vertical-field margin-right">
              <span className="label">{getMessage("company.companyType")}</span>
              <PxDropdownSc
                className={"document-types-dropdown"}
                value={patientDocumentType}
                onChange={(e: any, { value }: DropdownProps) =>
                  this.onPatientDocumentTypeChange(value)
                }
                options={documentTypeOptions}
                clearable
                selectOnNavigation={false}
                selection
                search
                fluid
              />
            </div>
          </div>

          <div className="actions-group right">
            <Button
              primary
              size="small"
              compact
              type="button"
              onClick={() => this.showModal()}
            >
              {getMessage("button.add")}
            </Button>
          </div>
        </div>

        {loadingData && <Loader active={true} size="small" />}

        {!loadingData && patientDocuments.length > 0 && (
          <TableInfoContainer>
            <Table className="documents-table" compact="very">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>
                    {getMessage("patientRecord.patientDocument.documentDate")}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {getMessage("patientRecord.patientDocument.type")}&nbsp;/&nbsp;
                    {getMessage("patientRecord.patientDocument.name")}&nbsp;/&nbsp;
                    {getMessage("patientRecord.patientDocument.patientDescription")}&nbsp;/&nbsp;
                    {getMessage("patientRecord.patientDocument.uploadPatientDocument.doctor")}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {getMessage("patientRecord.patientDocument.uploadPatientDocument.comment")}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {getMessage("patientRecord.patientDocument.actionButtons")}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {patientDocuments.map(patientDocument => {
                  let dateClass = patientDocument.requiresAction
                    ? "requires-action"
                    : "";
                  if (patientDocument.abnormalFinding) {
                    dateClass = "abnormal-finding";
                  }

                  return (
                    <StyledTableRow key={patientDocument.id}>
                      <Table.Cell className={`document-date ${dateClass}`}>
                        <div>
                          {moment(patientDocument.documentDate).format(
                            "DD.MM.YYYY"
                          )}
                        </div>
                        {patientDocument.requiresAction && (
                          <Icon
                            name="warning circle"
                            color="yellow"
                            title={getMessage(
                              "patientRecord.patientDocument.requiresAction"
                            )}
                          />
                        )}
                        {patientDocument.requiresDoctorAction && (
                          <Icon
                            name={
                              patientDocument.requiresDoctorAction
                                ? "bell"
                                : "bell slash outline"
                            }
                            color="purple"
                            title={getMessage(
                              "patientRecord.patientDocument.requiresDoctorAction"
                            )}
                          />
                        )}
                        {patientDocument.abnormalFinding && (
                          <Icon
                            name={"flag"}
                            color="red"
                            title={getMessage(
                              "patientRecord.patientDocument.abnormalFinding"
                            )}
                          />
                        )}
                        {patientDocument.discussWithPatient && (
                          <Icon
                            name={"phone"}
                            color="blue"
                            title={getMessage(
                              "patientRecord.patientDocument.discussWithPatient"
                            )}
                          />
                        )}
                        {patientDocument.procedureCreated && (
                          <Icon
                            name={"dollar"}
                            color="green"
                            title={getMessage(
                              "patientRecord.patientDocument.procedureCreated"
                            )}
                          />
                        )}
                        {PatientReportStatus.CONTROLLED ===
                          patientDocument.reportStatus && (
                          <Icon
                            name="check circle"
                            color="green"
                            title={getMessage(
                              "patientRecord.patientDocument.controlledReport"
                            )}
                          />
                        )}
                      </Table.Cell>

                      <Table.Cell className="document-cell">
                        <div className="document-type">
                          {this.getDocumentTypeDescription(
                            patientDocument.type
                          )}
                        </div>
                        <div className="document-name">
                          {this.renderPatientDocumentName(patientDocument)}
                        </div>
                        <div className="document-description">
                          <span className="description-cell">
                            {patientDocument.description}
                          </span>
                        </div>
                        {patientDocument.doctorId && (
                          <div className="document-doctor">
                            <Icon name="doctor" />
                            {this.renderDoctorPatientDocumentCell(
                              patientDocument.doctorId
                            )}
                          </div>
                        )}
                        {patientDocument.currentProblem && (
                          <div className="document-currentProblem">
                            <span className="description-cell">
                              {patientDocument.currentProblem}
                            </span>
                          </div>
                        )}
                      </Table.Cell>

                      <Table.Cell className="single-line-cell-class">
                        {this.renderCommentCell(patientDocument)}
                      </Table.Cell>

                      <StyledCell>
                        {this.renderDownloadPatientDocumentCell(
                          patientDocument
                        )}
                      </StyledCell>
                    </StyledTableRow>
                  );
                })}
              </Table.Body>
            </Table>
          </TableInfoContainer>
        )}

        {this.renderEditSynopsisReport()}

        {this.renderEditPhysiotherapyReport()}
      </React.Fragment>
    );
  };

  renderEditSynopsisReport = (): React.ReactNode => {
    const { synopsisReportDetails, synopsisModalOpen, reportId } = this.state;

    const { currentPatient } = this.props;

    if (!synopsisModalOpen) {
      return <></>;
    }

    return (
      <UpsertSynopsisReportModal
        modalOpen={synopsisModalOpen}
        onCloseModal={this.closeSynopsisModal}
        patient={currentPatient}
        // treatmentId={selectedTreatment!.id}
        reportDetails={synopsisReportDetails}
        documentId={reportId}
      />
    );
  };

  renderEditPhysiotherapyReport = (): React.ReactNode => {
    const {
      physiotherapyModalOpen,
      physiotherapyReportDetails,
      reportId
    } = this.state;

    const { currentPatient } = this.props;

    if (!physiotherapyModalOpen) {
      return <></>;
    }

    return (
      <UpsertPhysiotherapyReportModal
        modalOpen={physiotherapyModalOpen}
        onCloseModal={this.closePhysiotherapyModal}
        patient={currentPatient}
        // treatmentId={selectedTreatment!.id}
        reportDetails={physiotherapyReportDetails}
        documentId={reportId}
        requiredDataLoaded={true}
      />
    );
  };

  renderTable = (bookings: VaccinationDto[]): JSX.Element => {
    const { getMessage } = this.props;

    const tableColumns: ExtendedColumnProps[] = [
      {
        width: 200,
        flexGrow: 1,
        flexShrink: 0,
        label: getMessage("patientRecord.vaccination.medicament"),
        dataKey: "medicamentDescription"
      },
      {
        width: 150,
        flexGrow: 0,
        flexShrink: 0,
        label: getMessage("patientRecord.vaccination.dosis"),
        dataKey: "dosis"
      },
      {
        width: 150,
        flexGrow: 0,
        flexShrink: 0,
        label: getMessage("patientRecord.vaccination.date"),
        dataKey: "date",
        cellRenderer: this.dateCellRenderer
      }
    ];

    return (
      <StyledTable
        rowGetter={this.vaccinationsRowGetter(bookings)}
        rowRenderer={this.vaccinationsRowRenderer(bookings)}
        rowCount={bookings.length}
        rowHeight={38}
        columns={tableColumns}
      />
    );
  };

  vaccinationsRowGetter = (bookings: VaccinationDto[]) => ({ index }: any) => {
    if (bookings[index]) {
      Object.assign(bookings[index], { index: index + 1 });

      return bookings[index];
    }

    return {
      index: index + 1
    };
  };

  vaccinationsRowRenderer = (bookings: VaccinationDto[]) => ({
    className,
    columns,
    index,
    key,
    style
  }: any) => {
    const a11yProps = { "aria-rowindex": index + 1 };

    let styles = { ...style };

    const { id } = bookings[index];

    return (
      <div
        {...a11yProps}
        className={className}
        key={key}
        role="row"
        style={styles}
      >
        {columns}
      </div>
    );
  };

  dateCellRenderer = (data: any) => {
    const { rowData } = data;

    const bookingDate = isoToDisplayDate(rowData.date);

    return (
      <div>
        <div className="date birth-date" title={bookingDate}>
          {bookingDate}
        </div>
      </div>
    );
  };

  renderPatientHistoryPane = (): React.ReactNode => {
    const { currentPatient } = this.props;

    const { patientRecordLoading } = this.state;

    if (patientRecordLoading) {
      return <Loader active={true} size="small" />;
    }

    if (!currentPatient) {
      return <></>;
    }

    return (
      <PatientHistory
        patientDocumentTypesMap={this.state.patientDocumentTypesMap}
        patient={currentPatient}
      />
    );
  };
}

export default withMessages(
    withRouterWorkaround(
        withPatientContext(
            withPatientCentralRefDataContext(
                withAuthContext(ClinicalDataRecordView)))));
